import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Field } from '@dossierhq/design';
import { FieldDisplay } from './FieldDisplay.js';
export function EntityDisplay({ entity, schema }) {
    const entitySpec = schema.getEntityTypeSpecification(entity.info.type);
    if (!entitySpec)
        return null;
    return (_jsx(_Fragment, { children: entitySpec.fields.map((fieldSpec) => (_jsx(EntityFieldDisplay, { value: entity.fields[fieldSpec.name], fieldSpec: fieldSpec }, fieldSpec.name))) }));
}
function EntityFieldDisplay({ value, fieldSpec, }) {
    return (_jsxs(Field, { children: [_jsx(Field.Label, { children: fieldSpec.name }), _jsx(Field.Control, { children: _jsx(FieldDisplay, { value: value, fieldSpec: fieldSpec }) })] }));
}
//# sourceMappingURL=EntityDisplay.js.map